"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WizardSummary = void 0;
const react_1 = __importStar(require("react"));
const helpers_1 = require("../helpers");
const getFieldContents_1 = require("./helpers/getFieldContents");
const WordBreak_1 = require("./types/WordBreak");
const WizardSummary_styles_1 = require("./WizardSummary.styles");
exports.WizardSummary = (0, helpers_1.createUIElement)('WizardSummary', function (_a, ref) {
    var { className, labelWidth = 'auto', fieldsets, fieldContentWordBreak = WordBreak_1.WORD_BREAK.breakAll, onKeyDown, onKeyUp, onKeyPress, ['data-selector-id']: initialDataSelectorId, style } = _a, rest = __rest(_a, ["className", "labelWidth", "fieldsets", "fieldContentWordBreak", "onKeyDown", "onKeyUp", "onKeyPress", 'data-selector-id', "style"]);
    const dataSelectorId = (0, react_1.useMemo)(() => initialDataSelectorId || 'wizard-summary', [initialDataSelectorId]);
    const fields = (0, react_1.useMemo)(() => fieldsets === null || fieldsets === void 0 ? void 0 : fieldsets.map((fieldset) => {
        const { title, fields, renderBody, renderBodyPosition } = fieldset;
        const fieldContents = (0, getFieldContents_1.getFieldContents)({
            labelWidth,
            fields,
            wordBreak: fieldContentWordBreak
        });
        const isEmptyFragment = !title && !renderBody && fieldContents.length === 0;
        return (!isEmptyFragment && {
            title,
            fieldContents,
            renderBody,
            renderBodyPosition
        });
    }).filter(Boolean), [fieldContentWordBreak, fieldsets, labelWidth]);
    return (react_1.default.createElement(WizardSummary_styles_1.StyledWizardSummary, Object.assign({}, rest, { "data-selector-id": dataSelectorId, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style, className: (0, helpers_1.cn)('vm-WizardSummary', className) }), fieldsets &&
        (fields === null || fields === void 0 ? void 0 : fields.map(({ title, fieldContents, hasBorder = true, renderBody, renderBodyPosition }, idx) => (react_1.default.createElement(WizardSummary_styles_1.StyledWizardSummaryFieldset, { key: `fieldset-${idx}`, title: title, fieldContents: fieldContents, customBody: renderBody, customBodyPosition: renderBodyPosition, hasBorder: !!idx && hasBorder }))))));
});
//# sourceMappingURL=WizardSummary.js.map